const FinanReducer = (state = [], {type, load}) => {

//   const deteAdd = ({curSt, payLoad}) => {
//       if(state.length === 0) {
//       payLoad._id = 1
//       return [payLoad]

//     } 
//     if(state.length > 0)  {
//         let newSt = [...curSt, payLoad]
 
//         let checkArr =  newSt.filter(s => s._id )
//        if(checkArr.length < newSt.length) {
//         let resM = newSt.map(s => {
     
//           s._id =  newSt[0]._id++
  
//           return s
//         })
   
//           return [...resM]
//        } 
//        else {
// curSt.map(s => {
//   s._id = s._id + s[0]._id++
// })
//        }
      
        
//     }

     
//   }

      switch (type) {

        case 'ADD_FS': 

           // console.log(state.length) 
        //  console.log( state.map(s => s._id) )  
        
        if(state.length > 0) {
          // let st_maxID = Math.max( ...state.map(s => s._id) ) 
          
           let newSt = state.map(s => {s._id = Math.max( ...state.map(s => s._id) ) + 2; return s} )

           let maxID = Math.max( ...newSt.map(s => s._id) ) 
           
          load._id = maxID + load._id
          load.updated = true;

            return [...newSt, load]

        } 

        return  [...state, load]
       
        //  return deteAdd({curSt: state, payLoad:load})
          
      

         
             
        case 'REM_FS': return state.filter(s => s._id !== load);

        case 'Ch_Co':
            let sL = state
            let getItem = sL.slice(-1)
            let desiredItem = getItem[0]._id
            let obJ = sL.filter(s => s._id === desiredItem)
     
            obJ[0].color = load
               
            return [...sL]

        case 'SPENT_BUDG':
               // let sttL = state.slice(-1)
               // let lastItemID = sttL[0]._id


             let targetObj = state.filter(s => s.budg === load.budg)
             let initMon = targetObj[0].money
             let newMon = initMon - load.amt
             targetObj[0].diff = load.amt //amount actually spent
             targetObj[0].money = newMon //balance of the transaction
             targetObj[0].day = new Date().toDateString().substring(0,4).trim()
             targetObj[0].dayNo = Number( new Date().toDateString().substring(7,10).trim() )
             targetObj[0].month = new Date().toDateString().substring(4,7).trim()
             targetObj[0].year = Number( new Date().toDateString().substring(10,15).trim() )           
             targetObj[0].timeTrans = Date().substring(15, 21).trim()
             targetObj[0].spendBol = true
             targetObj[0].recivBol = false
             targetObj[0].updated = true
             targetObj[0].purpose = load.purpose
            //  targetObj[0].color = 'red' I omitted this code because it affects the /finance page
            state.filter(s => s.budg !== load.budg).map(s => {s.updated = false; return s})
            

             let newSB = state.map(s =>  {
              s._id = state[0]._id + s._id
              return s
              })
 


             return newSB
        
        case 'RECIV_BUDG':
          
          // let stL = state.slice(-1)
          // let lastItemId = stL[0]._id
          let newS =  state.map(s => {
          let unitMon = load.amt * s.rPerc / 100

            let newMon = s.money + unitMon
            s.diff = unitMon // money recieved and allocated to this budget
            s.money = newMon
            s.day = new Date().toDateString().substring(0,4).trim()
            s.dayNo = Number( new Date().toDateString().substring(7,10).trim() )
            s.month = new Date().toDateString().substring(4,7).trim()
            s.year = Number( new Date().toDateString().substring(10,15).trim() )
            s.timeTrans = Date().substring(15, 21).trim()
            s.purpose = load.purpose
            s.recivBol = true
            s.spendBol = false
            s.updated = true
            s._id = state[0]._id + s._id

            return  s
        })
         return newS

        case 'SPEC_RECIV_BUDG':
        let targetObj_Spec = state.filter(s => s.budg === load.budg)
        let init_Mon = targetObj_Spec[0].money
        let new_Mon = init_Mon + Number( load.amt )
        targetObj_Spec[0].diff = Number( load.amt ) //amount actually reciv
        targetObj_Spec[0].money = new_Mon //balance of the transaction
        targetObj_Spec[0].day = new Date().toDateString().substring(0,4).trim()
        targetObj_Spec[0].dayNo = Number( new Date().toDateString().substring(7,10).trim() )
        targetObj_Spec[0].month = new Date().toDateString().substring(4,7).trim()
        targetObj_Spec[0].year = Number( new Date().toDateString().substring(10,15).trim() )           
        targetObj_Spec[0].timeTrans = Date().substring(15, 21).trim()
        targetObj_Spec[0].spendBol = false
        targetObj_Spec[0].recivBol = true
        targetObj_Spec[0].updated = true
        targetObj_Spec[0].purpose = load.purpose
       //  targetObj[0].color = 'red' I omitted this code because it affects the /finance page
       state.filter(s => s.budg !== load.budg).map(s => {s.updated = false; return s})
       

        let new_SB = state.map(s =>  {
         s._id = state[0]._id + s._id
         return s
         })



        return new_SB                
        // case 'INFORM_UI': return [load]

        case 'UPDATE_S_API': 
        state.shift()
         return [...state, ...load]
        
        default: return state
    }
}

export default FinanReducer